import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { UserService } from "../../../modules/user/services/user.service";
import { CamerallaAuthService } from "../authentication-services/cameralla-auth.service";

@Injectable({
  providedIn: "root",
})
export class CamerallaAuthGuardService implements CanActivate, CanActivateChild {
  code;
  public site = environment["site"];

  constructor(
    private authService: CamerallaAuthService,
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.code = route.queryParamMap.get("code");
    let linkNavigateFrom = window.location.href.replace(/^.*\/\/[^\/]+/, "");
    if (this.code) {
      return new Promise<boolean>(resolveParent => {
        this.authService.login(this.code).then(
          response => {
            let localUserId = +this.authService.getLocalUserInfo()["id"];

            if (!response) {
              window.location.href = this.site;
            } else {
              this.userService.getPersonalDetails(localUserId).then(data => {
                if (localStorage.getItem("miss-login")) {
                  let url = JSON.parse(localStorage.getItem("miss-login"));
                  if (url.substring(1, 5) == "club") {
                    url = url.substring(6, url.length);
                  }
                  this.router.navigateByUrl(url);
                } else if (data.isCanon) {
                  this.router.navigate(["/canon"]);
                } else if (data.isHurtigruten) {
                  this.router.navigate(["/hurtigruten/4"]);
                } else if (data.isKampsport) {
                  this.router.navigate(["/kampsport/5"]);
                } else if (data.isNAF) {
                  this.router.navigate(["/naf/6"]);
                } else {
                  this.router.navigate(["/"]);
                }

                localStorage.removeItem("miss-login");
                resolveParent(true);
              });
            }
          },
          err => {
            resolveParent(false);
          }
        );
      });
    } else {
      if (!this.authService.isAuthenticated()) {
        localStorage.setItem("miss-login", JSON.stringify(linkNavigateFrom));
        window.location.href = this.site + "login";
      }

      // Auto generate camerallaUser key if lost in the local storage
      if (!localStorage.getItem("camerallaUser")) {
        localStorage.setItem("miss-login", JSON.stringify(linkNavigateFrom));
        // window.location.href =
        //   environment.site +
        //   "/oauth/authorize?response_type=code&client_id=" +
        //   environment.callbackToken;

        window.location.href = environment.site + "auth";
      }

      return this.authService.isAuthenticated();
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      window.location.href = this.site + "login";
    }

    return this.authService.isAuthenticated();
  }
}
//
